import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config';
import { useAuth } from './AuthContext';

const EventsContext = createContext();

export const EventsProvider = ({ children }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isLoggedIn } = useAuth();

  const fetchEvents = async () => {
    try {
      const response = await axios.get(`${config.API_BASE_URL}/events/all/`, {
        headers: isLoggedIn ? { Authorization: `Bearer ${localStorage.getItem("access_token")}` } : {}
      });
      
      let eventsData = [];
      const responseData = response.data;
      
      if (Array.isArray(responseData)) {
        eventsData = responseData;
      } else if (responseData?.results) {
        eventsData = responseData.results;
      } else if (responseData?.events) {
        eventsData = responseData.events;
      } else if (typeof responseData === 'object') {
        eventsData = [responseData];
      }
      
      setEvents(eventsData);
    } catch (error) {
      console.error('Error fetching events:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, [isLoggedIn]);

  return (
    <EventsContext.Provider value={{ events, loading, refreshEvents: fetchEvents }}>
      {children}
    </EventsContext.Provider>
  );
};

export const useEvents = () => {
  const context = useContext(EventsContext);
  if (!context) {
    throw new Error('useEvents must be used within an EventsProvider');
  }
  return context;
};
